import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import ContentLoader from '@adsk/alloy-react-content-loader';

const ProjectRowLoaderItem = () => (
  <ContentLoader width={285} height={50} viewBox="0 0 285 50">
    <rect x="65" y="17" rx="3" ry="3" width="120" height="6" />
    <rect x="65" y="30" rx="3" ry="3" width="180" height="6" />
    <rect x="0" y="0" rx="8" ry="8" width="48" height="48" />
  </ContentLoader>
);

const ProjectRowLoader = () => (
  <>
    <Flex
      data-testid="ProjectRowLoader"
      alignItems="center"
      height="80px"
      padding="8px 16px"
    >
      <ProjectRowLoaderItem />
    </Flex>
    <Flex alignItems="center" height="80px" padding="8px 16px">
      <ProjectRowLoaderItem />
    </Flex>
    <Flex alignItems="center" height="80px" padding="8px 16px">
      <ProjectRowLoaderItem />
    </Flex>
  </>
);

ProjectRowLoader.displayName = 'ProjectRowLoader';

export default ProjectRowLoader;
